import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Map2Legend: React.FC = () => {
  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Map Legend
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: '#90EE90',
              border: '2px solid #228B22',
              borderRadius: 1
            }}
          />
          <Typography variant="body2">AG</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: '#FFB6C1',
              border: '2px solid #DC143C',
              borderRadius: 1
            }}
          />
          <Typography variant="body2">SAM</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default Map2Legend; 